import axios from 'axios';

export const sendMarkdownToWeChatBot = async (message) => {
    try {
        const response = await axios.post('/api/wechat/send', {
            markdownMessage: message,
        });

        console.log('Message sent successfully:', response.data);
    } catch (error) {
        console.error('Error sending message:', error.message);
    }
};
